<section class="cmn-innerpage-wrapper expenses">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>

    <div class="form-wrapper" style="padding-top: 10px">
      <form [formGroup]="dateRangeForm">
        <mat-form-field>
          <mat-date-range-input
            [rangePicker]="picker"
            [dateFilter]="dateFilter"
          >
            <input
              matStartDate
              placeholder="Start date"
              formControlName="startDate"
              (dateInput)="onDateChange($event, 'start')"
            />
            <input
              matEndDate
              placeholder="End date"
              formControlName="endDate"
              (dateInput)="onDateChange($event, 'end')"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </form>
    </div>

    <div>
      <button class="cmn-upload-btn" (click)="onClear()">
        <img src="assets/images/icons/icon-close.svg" alt="Clear icon" />
        <span>Clear Filter</span>
      </button>
    </div>

    <div class="right-set">
      <button class="cmn-add-btn" (click)="openDialog()" *ngIf="canCreateExpenses$ | async">
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
        Expense
      </button>
      <button class="cmn-export-btn" (click)="toggleExport($event)">
        <img src="assets/images/icons/icon-export.svg" alt="Filter Icon" />
      </button>
    </div>
    <div
      [ngClass]="{ show: isExportOpen }"
      class="common-dropdown export-position"
      #export
    >
      <button class="close-dropdown" (click)="toggleExport($event)"></button>
      <h2>Export Table</h2>

      <div class="check-wrapper">
        <div class="check-box" *ngFor="let field of fieldOptions">
          <label class="checkbox-wrapper">
            <input
              type="checkbox"
              (change)="onFieldCheckboxChange($event, field.key)"
            />{{ field.label }}
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <h2>File Type</h2>

      <div class="format-selection">
        <label class="radiobtn-wrapper">
          <input
            type="radio"
            name="exportFormat"
            value="pdf"
            [(ngModel)]="exportFormat"
          />
          <span class="radiomark"></span>
          PDF
        </label>
        <label class="radiobtn-wrapper">
          <input
            type="radio"
            name="exportFormat"
            value="csv"
            [(ngModel)]="exportFormat"
          />
          <span class="radiomark"></span>
          CSV
        </label>
      </div>

      <div class="btn-wrapper">
        <button class="cmn-apply-btn" type="submit" (click)="exportExpenses()">
          <span *ngIf="!exportLoading">Export</span>
          <span *ngIf="exportLoading">Exporting...</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="canListExpenses$ | async">
    <div class="inner-content">
      <ag-grid-angular
        style="width: 100%"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowSelection]="rowSelection"
        [suppressRowClickSelection]="true"
        [class]="themeClass"
        (cellClicked)="onCellClicked($event)"
        (filterChanged)="onFilterChanged()"
        (gridReady)="onGridReady($event)"
      />
    </div>
    <div class="pagination-wrapper">
      <div class="page-size">
        <label for="pageSize">Page Size:</label>
        <select
          id="pageSize"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange($event)"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
      </div>
      <div class="page-nav" *ngIf="totalPages > 1">
        <button class="prev" (click)="prevPage()" [disabled]="page === 0">
          <img
            src="../../../assets/images/icons/arrow.svg"
            alt="prev arrow"
            srcset=""
          />
        </button>
        <span> Page {{ page + 1 }} of {{ totalPages }} </span>
        <button
          class="next"
          (click)="nextPage()"
          [disabled]="page + 1 >= totalPages"
        >
          <img
            src="../../../assets/images/icons/arrow.svg"
            alt="next arrow"
            srcset=""
          />
        </button>
      </div>
    </div>
  </div>
</section>
